import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';
import * as Styles from '../Icon.module.scss';

export function DeleteOutlineIcon({ size = 'xsmall', fill = 'black' }: IconProps) {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 18 20"
        >
            <path
                className={fillStyles}
                d="M2.06 4l.717 12.176A3 3 0 005.772 19h6.456a3 3 0 002.995-2.824L15.94 4H2.061zM12 0a.5.5 0 01.464.314l1 2.5a.499.499 0 01.036.187L12.461 3l.075.186a.5.5 0 00.563.304l.087-.026a.5.5 0 00.314-.463L17 3l-.779 13.235A4 4 0 0112.228 20H5.772a4 4 0 01-3.993-3.765L1 3l3.5.001c0-.062.011-.125.036-.187l1-2.5A.5.5 0 016 0h6zM6.475 6a.5.5 0 00-.474.525l.5 10a.5.5 0 10.998-.05l-.5-10a.5.5 0 00-.524-.474zm5.05 0a.5.5 0 00-.524.475l-.5 10a.5.5 0 00.998.05l.5-10a.5.5 0 00-.474-.524zm.136-5H6.34l-.801 2-1.038.001a.5.5 0 00.234.422l.08.041a.5.5 0 00.65-.278L5.538 3h6.923l-.8-2zM.5 4a.5.5 0 010-1h17a.5.5 0 110 1H.5z"
            ></path>
        </svg>
    );
}
